import { ReactElement } from "react";
import { UploadButton } from "react-uploader";
import { Uploader } from "uploader";

import { Button } from "../catalyst/Button";
import { Field } from "../catalyst/Field";
import { Input } from "../catalyst/Input";
import { Label } from "../catalyst/Label";
import IntegrationIcon from "../IntegrationIcon";

// Initialize once (at the start of your app).
const uploader = Uploader({
  apiKey: "free", // Get production API keys from Bytescale
});

const options = {
  maxFileSizeBytes: 50000,
  mimeTypes: ["image/*"],
  multi: false,
};

type Props = {
  onUpload(fileUrl: string, originalFileName: string): void;
  originalFileName?: string;
  showImageIcon?: boolean;
  uploadedUrl?: string;
};

const FileUploadButton = ({
  onUpload,
  originalFileName,
  showImageIcon = false,
  uploadedUrl,
}: Props): ReactElement => {
  const placeholderText = originalFileName ?? "Jpg, png, or svg";

  const placeholderComponent =
    showImageIcon && uploadedUrl ? (
      <IntegrationIcon className="h-10" src={uploadedUrl ?? ""} />
    ) : (
      <Input
        className="min-w-0 flex-1"
        disabled={true}
        placeholder={placeholderText}
      />
    );

  return (
    <Field>
      <Label>Upload Custom Icon (Optional)</Label>
      <UploadButton
        onComplete={(files) => {
          if (files.length > 0) {
            const file = files[0];
            onUpload(file.fileUrl, file.originalFile.file.name);
          }
        }}
        options={options}
        uploader={uploader}
      >
        {({ onClick }) => (
          <div className="flex items-center space-x-2 pt-3">
            {placeholderComponent}
            <Button onClick={onClick} outline>
              Upload File
            </Button>
          </div>
        )}
      </UploadButton>
    </Field>
  );
};

export default FileUploadButton;
